<template>
  <div class="mm-row-block" v-loading="loading">
    <el-form ref="form" :model="form" :rules="rules" label-width="180px" label-position="left">
      <div class="form-isheader-group">
        <div class="group-title">
          <h3>基本資料</h3>
        </div>
        <div class="form-isheader-group-content">
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="舊會員編號">
                <el-input v-model="form.old_customer_num" clearable></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="公司注冊地" prop="country_id">
                <el-input v-model="form.country_id" v-show="false"></el-input>
                <countryselect :form="form"></countryselect>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="公司名稱" prop="name">
                <el-input v-model="form.name" clearable></el-input>
                <el-radio v-if="examineStatus()" v-model="form.examine_radio" label="0">以此作為審查</el-radio>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="英文名稱" prop="ename">
                <el-input clearable v-model="form.ename" clearable></el-input>
                <el-radio v-if="examineStatus()" v-model="form.examine_radio" label="1">以此作為審查</el-radio>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="公司編號" prop="company_num">
                <el-input v-model="form.company_num" clearable></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="商業登記證號碼" prop="company_card">
                <el-input v-model="form.company_card" clearable></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="商業登記證號碼有效日期" prop="company_card_date">
                <el-date-picker v-model="form.company_card_date" type="date" placeholder="選擇日期" style="width:100%">
                </el-date-picker>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="地址" prop="address">
                <el-input v-model="form.address" clearable>
                  <el-button slot="append" @click="form.address=sify(form.address)">繁轉簡</el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="業務性質" prop="company_type">
                <el-input v-model="form.company_type" clearable></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="公司電話號碼" prop="phone">
                <el-input v-model="form.phone" clearable></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="公司電郵" prop="email">
                <el-input v-model="form.email" clearable></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="備註" prop="remarks">
                <el-input v-model="form.remarks" clearable>
                  <el-button slot="append" @click="form.remarks=sify(form.remarks)">繁轉簡</el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
      <el-card class="box-card mb10" shadow="never">
        <div slot="header" class="clearfix">
          <h3>股東 及 董事</h3>
        </div>
        <div class="text item">
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="股東姓名" required>
                <el-input v-model="form.stockholder[0].name" clearable></el-input>
              </el-form-item>
            </div>
            <div class="mm-col flex50 ml-20">
              <el-form-item label="董事姓名" required>
                <el-input v-model="form.director[0].name" clearable></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-card>
      <el-card class="box-card mb10" shadow="never">
        <div slot="header" class="clearfix">
          <h3>獲授權人</h3>
        </div>
        <div class="text item">
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="姓名" required>
                <el-input v-model="form.authorizer[0].name" clearable></el-input>
              </el-form-item>
            </div>
            <div class="mm-col flex50 ml-20">
              <el-form-item label="電話號碼" required>
                <el-input v-model="form.authorizer[0].phone" clearable></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-card>
      <div class="form-isheader-group">
        <div class="group-title">
          <h3>會員文件</h3>
        </div>
        <div class="form-isheader-group-content">
          <div class="flex-start">
            <h3 style="margin-right:20px">上傳要求:</h3>
            <div class="notice">支持JPEG、JPG、PNG、PDF文件上傳</div>
          </div>
          <component :type="form.type" :showdata.sync="form.customer_files_list" :files.sync="form.customer_upload_list" :disabled="isreadonly" :is="component_name"></component>
        </div>
      </div>
      <div class="form-isheader-group">
        <div class="group-title">
          <h3 class="mr15">審查結果 Name Screening Result</h3>
          <div class="shengchabon" v-if="examineStatus()">
            <el-input-number class="mr15 pcshow2" v-model="form.shengchascore" :min="0" :max="100" label="審查起始分數"></el-input-number>
            <el-button @click="examine" type="primary" plain>在線審查</el-button>
          </div>
        </div>
        <div class="form-isheader-group-content">
          <template v-if="examineStatus()">
            <div v-if="form.dowjones" style="margin-bottom: 20px;">
              <div class="group-sub-title">
                <div class="dowjones-logo"><img src="@/assets/dowjones_s.png"></div>
              </div>
              <el-table empty-text="暫無數據" :data="form.dowjonesdata" border :header-cell-style="{background:'#FAFAFA'}">
                <el-table-column align="center">
                  <template slot-scope="scope">
                    <div class="phonecel"></div>
                    <span class="riskicon">{{scope.row.riskicon}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="名稱" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">名稱</div>
                    <div class="dowjonesdata_primaryname">
                      <span>{{scope.row.primaryname}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="檔案簡要" width="300px" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">檔案簡要</div>
                    <template v-for="(item,i) in scope.row.content">
                      <div :key="i" style="text-align:left;">
                        檔案編號：{{item.peid}} <br>符合姓名：{{item.matchedname}} <br>匹配性別：{{item.gender}} <br>出生日期：{{item.birthday}} <br>匹配精度：{{item.matchtype}}
                      </div>
                    </template>
                  </template>
                </el-table-column>
                <el-table-column label="國家/地區" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">國家/地區</div>
                    <span>{{scope.row.country}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="標題" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">標題</div>
                    <span>{{scope.row.title}}</span>
                  </template>
                </el-table-column>

                <el-table-column label="子公司" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">子公司</div>
                    <span>{{scope.row.subsidiary}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Score" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">Score</div>
                    <span style="color:red" v-if="scope.row.score>90">{{scope.row.score}}</span>
                    <span v-if="scope.row.score<=90 && scope.row.score>0">{{scope.row.score}}</span>
                    <span style="color:green" v-if="scope.row.score==0">{{scope.row.score}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="查詢時間" align="center">
                  <template slot-scope="scope">
                    {{scope.row.addtime}}
                  </template>
                </el-table-column>
                <el-table-column label="详细" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">详细</div>
                    <span>
                      <el-button @click="showdowjones_info_fun(scope.row.content[0].peid,0)">查看</el-button>
                    </span>

                  </template>
                </el-table-column>
              </el-table>
              <el-dialog :visible.sync="form.showdowjones" :append-to-body='true'>
                <div class="showdowjones" v-if="form.showdowjones">
                  <div class="showdowjones_pdf">
                    <div class="dowjones_pdf"><a href="javascript:void(0)" @click="importpdf(form.showdowjonesinfo,0)">导出PDF</a></div>
                  </div>
                  <div class="showdowjones_row flex">
                    <div>檔案 ID 編號:</div>
                    <div>{{form.showdowjonesinfo.peid}}</div>
                  </div>
                  <div class="showdowjones_row flex">
                    <div>類型:</div>
                    <div>{{form.showdowjonesinfo.type}}</div>
                  </div>
                  <div class="showdowjones_row flex">
                    <div>性別:</div>
                    <div>{{form.showdowjonesinfo.gender}}</div>
                  </div>
                  <div class="showdowjones_row">
                    <div>姓名:</div>
                    <div>
                      <div v-for="(item,i) in form.showdowjonesinfo.names" :key="i">{{item}}</div>
                    </div>
                  </div>
                  <div class="showdowjones_row">
                    <div>國家:</div>
                    <div>
                      <div v-for="(item,i) in form.showdowjonesinfo.country" :key="i">
                        <span>{{item.countrytype}}</span> <span>{{item.country}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="showdowjones_row imggroup">
                    <div>照片:</div>
                    <div>
                      <div v-for="(item,i) in form.showdowjonesinfo.image" :key="i"><a :href="item" target="_blank"><img :src="item"></a></div>
                    </div>
                    <div>
                      <div style="margin-bottom: 10px; " v-for="(item,i) in form.showdowjonesinfo.image" :key="i"><a style="color: #3399FF;" :href="item" target="_blank">{{item}}</a></div>
                    </div>
                  </div>
                  <div class="showdowjones_row">
                    <div>資料:</div>
                    <div>
                      <div v-for="(item,i) in form.showdowjonesinfo.watchlist" :key="i">{{item}}</div>

                    </div>
                  </div>
                  <div class="showdowjones_row">
                    <div>職位:</div>
                    <div>
                      <div v-for="(item,i) in form.showdowjonesinfo.jobs" :key="i">
                        <div>{{item.jobtype}}</div>
                        <div>{{item.job}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-dialog>
              <div class="dowjones_pdf" v-show="form.dowjones_pdf&&form.dowjones_pdf!=''">
                <div class="pdf-btn-box">
                  <a :href="form.dowjones_pdf" target="_blank">
                    <img src="@/assets/pdf.png">
                  </a>
                  <div class="pdf-title">Search Result PDF</div>
                </div>
                <template v-for="(item,i) in form.showdowjones_pdfs">
                  <div class="pdf-btn-box" :key="i">
                    <span v-if="!isreadonly" class="del-btn" @click="deldowjonespdf(item.peid,0)">
                      <i class="el-icon-circle-close"></i>
                    </span>
                    <a :href="item.fileurl" target="_blank">
                      <img src="@/assets/pdf.png">
                    </a>
                    <div class="pdf-title">檔案編號：{{item.peid}}</div>
                  </div>
                </template>
              </div>
            </div>
            <div v-else>
              <div style="margin-bottom: 20px;">
                <div class="group-sub-title">
                  <h3>OFAC</h3>
                </div>
                <el-table empty-text="暫無數據" :data="form.examinedata" border :header-cell-style="{background:'#FAFAFA'}">
                  <el-table-column label="Name" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">Name</div>
                      <span>{{scope.row.name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Address" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">Address</div>
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Type" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">Type</div>
                      <span>{{scope.row.type}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Program(s)" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">Program(s)</div>
                      <span>{{scope.row.program}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="List" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">List</div>
                      <span>{{scope.row.list}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Score" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">Score</div>
                      <span style="color:red" v-if="scope.row.score>90">{{scope.row.score}}</span>
                      <span v-if="scope.row.score<=90 && scope.row.score>0">{{scope.row.score}}</span>
                      <span style="color:green" v-if="scope.row.score==0">{{scope.row.score}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Url" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">Url</div>
                      <span v-if="scope.row.url"><a :href="scope.row.url" target="_blank">{{scope.row.url}}</a></span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Query Time" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">Query Time</div>
                      <span>{{scope.row.addtime}}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div style="margin-bottom: 20px;">
                <div class="group-sub-title">
                  <h3>UNSC</h3>
                </div>
                <el-table empty-text="暫無數據" :data="form.examinedataxml" border :header-cell-style="{background:'#FAFAFA'}">
                  <el-table-column label="Name" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">Name</div>
                      <span>{{scope.row.name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Type" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">type</div>
                      <span>{{scope.row.type}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Design" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">design</div>
                      <span>{{scope.row.design}}</span>
                    </template>
                  </el-table-column>

                  <el-table-column label="Date" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">date</div>
                      <span>{{scope.row.date}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Score" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">Score</div>
                      <span style="color:red" v-if="scope.row.score>90">{{scope.row.score}}</span>
                      <span v-if="scope.row.score<=90 && scope.row.score>0">{{scope.row.score}}</span>
                      <span style="color:green" v-if="scope.row.score==0">{{scope.row.score}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Url" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">url</div>
                      <span v-if="scope.row.url"><a :href="scope.row.url" target="_blank">{{scope.row.url}}</a></span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Query Time" align="center">
                    <template slot-scope="scope">
                      <div class="phonecel">Query Time</div>
                      <span>{{scope.row.addtime}}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div style="margin-bottom: 20px;" v-if="examineStatus()">
                <el-image style="width: 148px; height: 148px" :src="form.examineimg" :preview-src-list="form.examineimglist">
                </el-image>
              </div>
            </div>
          </template>
          <uploadimage :fileDir="'customer'" :oldImageUrlList.sync="form.review_files_list" :imageUrlList.sync="form.review_upload_list" listType="picture-card"></uploadimage>
        </div>
      </div>
      <div class="form-submit">
        <el-button type="primary" @click="formsubmit('form')">保存</el-button>
      </div>
    </el-form>
  </div>

</template>

<script>
import countryselect from "@/components/CountrySelect.vue";
import uploadimage from "@/components/Uploadimage.vue";
import CustomerFiles from "@/components/CustomerFiles.vue";
export default {
  components: {
    countryselect,
    uploadimage,
    CustomerFiles,
  },
  props: ['showdata'],
  name: "company",
  data () {
    return {
      component_name: 'CustomerFiles',
      isreadonly: false,
      loading: false,
      showpicurl: '',
      showpicbox: false,
      value1: 0,
      ordertype: -1,
      storelist: [],
      form: {
        card: '',
        address: '',
        company_card: '',
        staff_id:0,
        store_id:0,
        mso_id: 0,
        type: 1,
        country_id: '',
        review_files_list: [],
        review_upload_list: [],
        customer_files_list: [],
        customer_upload_list: [],
        shengchascore: 95,
        examineimg: '',
        examineimglist: [],
        examinedata: [],
        examineimgpath: '',
        examinedataxml: [],
        examine_radio: '0',
        // 股東和董事列表
        stockholder: [
          { name: "" }
        ],
        // 董事
        director: [
          { name: '' }
        ],
        // 獲受人信息 
        authorizer: [
          { name: "", phone: "" }
        ],
	dowjones: true,
        showdowjones: false,
        showdowjonesinfo: {},
        dowjones_pdf: '',
        dowjonesdata: [],
        showdowjones_pdfs: [],
      },
      rules: {
        phone: [{
          required: true,
          message: '請輸入電話號碼',
        },
        ],
        name: [{
          required: true,
          message: '請輸入會員名稱',
        }
        ],
        company_card: [{
          required: true,
          message: '請輸入商業登記證號碼',
        }
        ],
        company_card_date: [{
          required: true,
          message: '請輸入商業登記證有效期',
        }
        ],
        company_type: [{
          required: true,
          message: '請輸入業務性質',
        }
        ],
        country_id: [{
          required: true,
          message: '請選擇公司註冊地',
        }, {
          pattern: /^[1-9]\d*$/,
          message: '請選擇公司註冊地'
        },
        ],
        address: [{
          required: true,
          message: '請輸入公司地址',
        }
        ],
        email: [
          {
            type: 'email',
            message: '請輸入正確的郵箱地址',
            trigger: 'blur'
          }
        ]



      }
    }
  },
  methods: {
    get_examine_status () {
      if (this.examineStatus() == 2) {
        this.form.dowjones = true;
      } else {
        this.form.dowjones = false;
      }
    },
    deldowjonespdf (peid) {
      this.form.showdowjones_pdfs = this.form.showdowjones_pdfs.filter(item => {
        if (peid == item.peid) {
          return false;
        } else {
          return true;
        }
      })
    },
    importpdf (dowjonesinfo) {
      if (this.isReadonly) {
        window.open(dowjonesinfo.pdf, dowjonesinfo.peid);
        return flase;
      }
      let pdf = {};
      this.form.showdowjones_pdfs = this.form.showdowjones_pdfs.filter(item => {
        if (dowjonesinfo.peid == item.peid) {
          return false;
        } else {
          return true;
        }
      })
      pdf.peid = dowjonesinfo.peid;
      pdf.fileurl = dowjonesinfo.pdf;
      this.form.showdowjones_pdfs.push(pdf);
      this.form.showdowjones = false;
      window.open(dowjonesinfo.pdf, dowjonesinfo.peid);
    },
    riskicon_color (riskicon) {
      if (riskicon.indexOf('SAN') > -1) {
        return 'riskicon_san';
      } else if (riskicon.indexOf('PEP') > -1) {
        return 'riskicon_pep';
      } else {
        return 'riskicon_other';
      }
    },
    showdowjones_info_fun (peid) {
      if (peid) {
        this.loading = true;
        let mso_id = this.sessionRead('mso_id');
        let staff_id = this.sessionRead('staff_id');
        let store_id = this.form.store_id;
        this.post('api/order/dowjones_peid', {
          mso_id,
          staff_id,
          store_id,
          peid
        }).then(res => {
          this.loading = false;
          this.form.showdowjonesinfo = res;
          this.form.showdowjones = true;
        }).catch(error => {
          this.loading = false;
        })
      }
    },
    getstore () {
      let mso_id = this.sessionRead('mso_id');
      this.post('/api/order/getstore', {
        mso_id
      })
        .then(response => {
          if (response.length > 0) {
            this.storelist = response;
            this.form.store_id = response[0].id;
          }
        })
        .catch(error => { });
    },
    examine () {
      let examine_radio = this.form.examine_radio;
      let ename = null;
      if (examine_radio == '0') {
        ename = this.form.name;
      } else if (examine_radio == '1') {
        ename = this.form.ename;
      }


      let country_id = this.form.country_id;
      let clienttype = this.form.type;
      if (!ename) {
        this.$alert('<div class="alertbox"><i class="alert-error el-icon-error"></i> 請填寫審查姓名</div>', '提示', {
          dangerouslyUseHTMLString: true
        });
        return false;
      }

      if (this.form.dowjones) {
        this.loading = true;
        this.form.examineimg = '';
        this.form.examineimglist = [];
        let mso_id = this.sessionRead('mso_id');
        let staff_id = this.sessionRead('staff_id');
        let store_id = this.form.store_id;
        this.post('api/order/dowjones', {
          mso_id,
          store_id,
          staff_id,
          ename,
          clienttype,
          country_id
        }).then(res => {
          this.loading = false;
          if (res.status == 'error') {
            this.$alert('<div class="alertbox"><i class="alert-error el-icon-error"></i> 查詢失敗，請嘗試添加國籍，身份證，地址信息</div>',
              '提示', {
              dangerouslyUseHTMLString: true
            });
            return false;
          } else if (res.status == 'success') {
            this.form.dowjonesdata = res.data;
            this.form.dowjones_pdf = res.pdf;
            // console.log(this.dowjones_pdf);
          }
        }).catch(error => {
          this.loading = false;
          this.$alert('<div class="alertbox"><i class="alert-error el-icon-error"></i> 查詢失敗，請求超時</div>', '提示', {
            dangerouslyUseHTMLString: true
          });
          return false;
        });
      } else {
        let card = this.form.card;
        // 企業或行家時
        if (this.form.type != 0) {
          card = this.form.company_card;
        }
        let mso_id = this.sessionRead('mso_id');
        let address = this.form.address;
        let score = this.form.shengchascore;
        this.loading = true;
        this.form.examineimg = '';
        this.form.examineimglist = [];
        this.post('api/order/examine', {
          mso_id,
          ename,
          country_id,
          card,
          address,
          score
        })
          .then(res => {
            this.loading = false;
            if (res.status == 'error') {
              this.$alert('<div class="alertbox"><i class="alert-error el-icon-error"></i> 查詢失敗，請嘗試添加國籍，身份證，地址信息</div>', '提示', {
                dangerouslyUseHTMLString: true
              });
              return false;
            } else if (res.status == 'success') {
              this.form.examinedataxml = res.examinedataxml;
              this.form.examinedata = res.data;
              this.form.examineimg = res.thumburl;
              this.form.examineimgpath = res.thumburl2;
              this.form.examineimglist.push(res.thumburl);
            }

          }).catch(error => {
            this.loading = false;
            this.$alert('<div class="alertbox"><i class="alert-error el-icon-error"></i> 查詢失敗，請求超時</div>', '提示', {
              dangerouslyUseHTMLString: true
            });
            return false;
          });
      }

    },
    pageback () {
      this.$router.go(-1);
    },
    formsubmit (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let data = this.form;
          if (data.stockholder[0].name == '' || data.director[0].name == '' || data.authorizer[0].name == '' || data.authorizer[0].phone == '') {
            this.$message({
              showClose: true,
              message: '請填寫股東及董事，獲授權人必填字段后提交！',
              type: 'error',
            });
            return false;
          }


          this.loading = true;
          this.post('/api/customer/customer_edit',
            data
          ).then((res) => {
            if (res.status == 'success') {
              this.$message({
                showClose: true,
                message: '修改會員成功！',
                type: 'success',
                onClose: (() => {
                })
              });
            } else if (res.status == 'phone_exist') {
              this.$message({
                showClose: true,
                message: '對不起，該手機號碼已 註冊，會員編號為：' + res.data.customer_num,
                type: 'error',

              });
            } else {
              this.$message({
                showClose: true,
                message: '修改會員失敗，請重試！',
                type: 'error',

              });
            }

            this.loading = false;
          }).catch((err) => {
            this.loading = false;
            console.log(err)
          });
        } else {
          this.$message({
            showClose: true,
            message: '請填寫用戶信息，戶主名稱，電話號碼等必填字段后提交！',
            type: 'error',

          });
        }
      });
    },
  },
  created () {
    this.form = this.showdata;
    this.getstore();
    this.form.staff_id = this.sessionRead('staff_id');
    this.form.mso_id = this.sessionRead('mso_id');
    this.get_examine_status();	
  }
}
</script>

<style scoped>
.ml-20 {
  margin-left: 20px;
}
.mm-row {
  display: flex;
}
.flex50 {
  flex: 0 50%;
}
@media screen and (max-width: 1024px) {
  .ml-20 {
    margin-left: 0px;
  }
  .mm-row {
    display: block;
  }
  .flex50 {
    flex: 1 1 100%%;
  }
}
</style>
